// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/product-offering-slider-exchange/product-offering-slider-exchange.component.scss
// module id = 455
// module chunks = 0